import Layout from '../../internal/Layout.vue'
import filesRepository from './index.vue'

const filesRepositoryRoutes = {
  component: Layout,
  children: [
    {
      name: 'filesRepository',
      path: '/',
      component: filesRepository,
      meta: {
        module: 'filesRepository',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresSolicitor: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default filesRepositoryRoutes
